export const EXPERIMENTS_SCOPE = 'wix-events-ui'
